module.exports = __webpack_public_path__ + "static/media/leftarrow.e0284727.svg";